import { Box, Typography, type TypographyProps } from "@mui/material";
import type { ReactNode } from "react";
import type { SxProps, Theme } from "@mui/material/styles";

type EmptyStateProps = {
  title: string;
  description?: string;
  titleVariant?: TypographyProps["variant"];
  children?: ReactNode;
  sx?: SxProps<Theme>;
};

/**
 * Centered message block for empty and error pages.
 */
export function EmptyState({
  title,
  description,
  titleVariant = "h5",
  children,
  sx,
}: EmptyStateProps) {
  return (
    <Box sx={{ textAlign: "center", py: 8, ...sx }}>
      <Typography
        variant={titleVariant}
        sx={{
          color: "text.secondary",
          mb: 1,
        }}
      >
        {title}
      </Typography>
      {description != null && description !== "" && (
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            mt: 1,
          }}
        >
          {description}
        </Typography>
      )}
      {children}
    </Box>
  );
}
